import { Suspense } from "react";
import AppRouter from "./routes/AppRouter";

export const App = () => {
    return (
        <Suspense fallback="">
            <AppRouter />
        </Suspense>
    );
};
